
// import React, { useState, useEffect, useRef } from "react";
// import { useNavigate, useLocation } from "react-router-dom";
// import { Container, Card, Box, Typography, TextField, Snackbar, Alert } from "@mui/material";
// import { LoadingButton } from "@mui/lab";
// import { toast } from "react-toastify";
// import { useDispatch } from "react-redux";
// import { resendOtp } from "../actions/authActions";
// const Verification = () => {
//   const navigate = useNavigate();
//   const dispatch = useDispatch();
//   const location = useLocation();
//   const [otp, setOtp] = useState(["", "", "", "", ""]);
//   const [loading, setLoading] = useState(false);
//   const [timer, setTimer] = useState(120);
//   const [isTimerActive, setIsTimerActive] = useState(true);
//   const [isBlocked, setIsBlocked] = useState(false); 
//   const [snackbar, setSnackbar] = useState({ open: false, message: "", severity: "" }); 
//   const [resendLoading, setResendLoading] = useState(false);
//   const [sentOtp, setSentOtp] = useState(location.state?.sentOtp || "");
//   const inputRefs = useRef([]);
//   const { phoneNumber, userData } = location.state || {};
//   const [showResendTimer, setShowResendTimer] = useState(true); 
// const [resendTimer, setResendTimer] = useState(30);
//   useEffect(() => {
//     if (!phoneNumber || !sentOtp) {
//       toast.error("Invalid access. Redirecting to login.");
//       navigate("/login", { replace: true });
//     }
//   }, [phoneNumber, sentOtp, navigate]);
//   useEffect(() => {
//     if (isTimerActive && timer > 0) {
//       const countdown = setInterval(() => {
//         setTimer((prevTimer) => {
//           if (prevTimer <= 1) {
//             clearInterval(countdown);
//             setIsBlocked(true);
//             setSnackbar({
//               open: true,
//               message: "OTP time expired. Please request a new OTP.",
//               severity: "error",
//             });
//             return 0;
//           }
//           return prevTimer - 1;
//         });
//       }, 1000);
//       return () => clearInterval(countdown);
//     }
//   }, [timer, isTimerActive]);
//   const handleOtpChange = (e, index) => {
//     const value = e.target.value;
//     if (/[^0-9]/.test(value)) return;
//     const updatedOtp = [...otp];
//     updatedOtp[index] = value;
//     setOtp(updatedOtp);
//     if (value && index < otp.length - 1) {
//       inputRefs.current[index + 1]?.focus();
//     }
//   };
//   const handleKeyDown = (e, index) => {
//     if (e.key === "Backspace" && !otp[index]) {

//       if (index > 0) {
//         inputRefs.current[index - 1]?.focus();
//       }
//     }
//   };
//   const handleOtpSubmit = () => {
//     const enteredOtp = otp.join("");
//     if (!enteredOtp || enteredOtp !== sentOtp) { 
//       setSnackbar({
//         open: true,
//         message: "Invalid OTP. Please try again.",
//         severity: "error",
//       });
//       return;
//     }
//     setLoading(true);
//     setTimeout(() => {
//       setLoading(false);
//       setSnackbar({
//         open: true,
//         message: "OTP Verified Successfully!",
//         severity: "success",
//       });
//       localStorage.setItem("phoneNumber", phoneNumber);
//       localStorage.setItem("sentOtp", sentOtp);   
//       localStorage.setItem("userData", JSON.stringify(userData));
//       navigate("/home", { state: { phoneNumber, userData: userData?.ResultSet || null } });
//     }, 2000);
//   };

//   const handleResendOtp = async () => {
//     setResendLoading(true);
//     setShowResendTimer(false);  
//     setResendTimer(30); 
//     try {
//       const response = await dispatch(resendOtp(phoneNumber));
//       if (response.success) {
//         setTimer(90);
//         setIsBlocked(false);
//         setSnackbar({
//           open: true,
//           message: "OTP has been resent successfully.",
//           severity: "success",
//         });
//         setSentOtp(response.data);
//       } else {
//         setSnackbar({
//           open: true,
//           message: response.error.message || "Failed to resend OTP.",
//           severity: "error",
//         });
//       }
//     } catch (err) {
//       console.error("Error during resend OTP:", err);
//       setSnackbar({
//         open: true,
//         message: "Unexpected error. Please try again.",
//         severity: "error",
//       });
//     } finally {
//       setResendLoading(false);
//       const resendCountdown = setInterval(() => {
//         setResendTimer((prev) => {
//           if (prev <= 1) {
//             clearInterval(resendCountdown);
//             setShowResendTimer(true);  
//             return 0;
//           }
//           return prev - 1;
//         });
//       }, 1000);
//     }
//   };
//   const handleCloseSnackbar = () => {
//     setSnackbar((prevState) => ({ ...prevState, open: false }));
//   };
//   return (
//     <Container
//       sx={{
//         display: "flex",
//         flexDirection: "column",
//         justifyContent: "center",
//         alignItems: "center",
//         minHeight: "100vh",
//         backgroundColor: "#F8F9FA",
//         padding: 2,
//         position: "absolute",
//         top: 0,
//         left: 0,
//         right: 0,
//       }}
//     >
//       <Card sx={{ borderRadius: 5, boxShadow: 8, padding: 4, maxWidth: 400 }}>
//         <Box textAlign="center" mb={2}>
//           <Typography variant="h4" fontWeight={600}>
//             Verify OTP
//           </Typography>
//           <Typography variant="subtitle1" color="textSecondary" mt={1}>
//             Enter the OTP sent to {phoneNumber}
//           </Typography>
//         </Box>
//         <Box display="flex" justifyContent="space-between" mb={3}>
//           {otp.map((digit, index) => (
//             <TextField
//               key={index}
//               value={digit}
//               onChange={(e) => handleOtpChange(e, index)}
//               onKeyDown={(e) => handleKeyDown(e, index)}
//               inputProps={{
//                 maxLength: 1,
//                 disabled: isBlocked,
//               }}
//               sx={{
//                 width: "50px",
//                 textAlign: "center",
//                 '& input': { textAlign: 'center' },
//               }}
//               inputRef={(el) => (inputRefs.current[index] = el)}
//             />
//           ))}
//         </Box>
//         <Box textAlign="center" mb={2}>
//           {isTimerActive ? (
//             <Typography variant="body2" color="textSecondary">
//             Time left: {Math.floor(timer / 60)}:
//             {timer % 60 < 10 ? "0" + (timer % 60) : timer % 60}
//           </Typography>
//           ) : (
//             <Typography variant="body2" color="error">
//               OTP expired. Please request a new one.
//             </Typography>
//           )}
//         </Box>
//         <Box>
//   <LoadingButton
//     onClick={handleOtpSubmit}
//     loading={loading}
//     variant="contained"
//     sx={{
//       width: "100%",
//       backgroundColor: "#0049AF",
//       textTransform: "capitalize",
//       borderRadius: 3,
//       mb: 2,
//     }}
//     disabled={isBlocked}
//   >
//     <span style={{ color: "#fff", fontSize: 16, fontWeight: 400 }}>
//       Verify OTP
//     </span>
//   </LoadingButton>

//     {isBlocked && showResendTimer && (
//       <LoadingButton
//         onClick={handleResendOtp}
//         loading={resendLoading}
//         variant="outlined"
//         sx={{
//           width: "100%",
//           textTransform: "capitalize",
//           borderRadius: 3,
//         }}
//       >
//         <span style={{ fontSize: 16, fontWeight: 400 }}>Resend OTP</span>
//       </LoadingButton>
//     )}
//  {!showResendTimer && (
//     <Typography variant="body2" color="textSecondary" textAlign="center">
//       You can resend OTP in {resendTimer} seconds.
//     </Typography>
//   )}
// </Box>
//       </Card>
//       {/* Snackbar for displaying alerts */}
//       <Snackbar
//         open={snackbar.open}
//         autoHideDuration={3000}
//         onClose={handleCloseSnackbar}
//         anchorOrigin={{ vertical: "top", horizontal: "center" }}
//       >
//         <Alert onClose={handleCloseSnackbar} severity={snackbar.severity} sx={{ width: "100%" }}>
//           {snackbar.message}
//         </Alert>
//       </Snackbar>
//     </Container>
//   );
// };
// export default Verification;





import React, { useState, useEffect, useRef } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import {
  Container,
  Box,
  Typography,
  TextField,
  Snackbar,
  Alert,
  Link,
  InputAdornment,
  IconButton,
  Paper
} from "@mui/material";
import { LoadingButton } from "@mui/lab";
import { toast } from "react-toastify";
import { useDispatch } from "react-redux";
import { resendOtp } from "../actions/authActions";
import { Phone, Security, Timer, Refresh, ArrowBack } from "@mui/icons-material";

// Import your background image
import imge from "../assets/hom.gif";

const Verification = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const location = useLocation();
  const [otp, setOtp] = useState(["", "", "", "", ""]);
  const [loading, setLoading] = useState(false);
  const [timer, setTimer] = useState(120);
  const [isTimerActive, setIsTimerActive] = useState(true);
  const [isBlocked, setIsBlocked] = useState(false);
  const [snackbar, setSnackbar] = useState({ open: false, message: "", severity: "" });
  const [resendLoading, setResendLoading] = useState(false);
  const [sentOtp, setSentOtp] = useState(location.state?.sentOtp || "");
  const inputRefs = useRef([]);
  const { phoneNumber, userData } = location.state || {};
  const [showResendTimer, setShowResendTimer] = useState(true);
  const [resendTimer, setResendTimer] = useState(30);

  useEffect(() => {
    if (!phoneNumber || !sentOtp) {
      toast.error("Invalid access. Redirecting to login.");
      navigate("/", { replace: true });
    }
  }, [phoneNumber, sentOtp, navigate]);

  useEffect(() => {
    if (isTimerActive && timer > 0) {
      const countdown = setInterval(() => {
        setTimer((prevTimer) => {
          if (prevTimer <= 1) {
            clearInterval(countdown);
            setIsBlocked(true);
            setSnackbar({
              open: true,
              message: "OTP time expired. Please request a new OTP.",
              severity: "error",
            });
            return 0;
          }
          return prevTimer - 1;
        });
      }, 1000);
      return () => clearInterval(countdown);
    }
  }, [timer, isTimerActive]);

  const handleOtpChange = (e, index) => {
    const value = e.target.value;
    if (/[^0-9]/.test(value)) return;
    const updatedOtp = [...otp];
    updatedOtp[index] = value;
    setOtp(updatedOtp);
    if (value && index < otp.length - 1) {
      inputRefs.current[index + 1]?.focus();
    }
  };

  const handleKeyDown = (e, index) => {
    if (e.key === "Backspace" && !otp[index]) {
      if (index > 0) {
        inputRefs.current[index - 1]?.focus();
      }
    }
  };

  const handleOtpSubmit = () => {
    const enteredOtp = otp.join("");
    if (!enteredOtp || enteredOtp !== sentOtp) {
      setSnackbar({
        open: true,
        message: "Invalid OTP. Please try again.",
        severity: "error",
      });
      return;
    }
    setLoading(true);
    setTimeout(() => {
      setLoading(false);
      setSnackbar({
        open: true,
        message: "OTP Verified Successfully!",
        severity: "success",
      });
      localStorage.setItem("phoneNumber", phoneNumber);
      localStorage.setItem("sentOtp", sentOtp);
      localStorage.setItem("userData", JSON.stringify(userData));
      navigate("/home", { state: { phoneNumber, userData: userData?.ResultSet || null } });
    }, 2000);
  };

  const handleResendOtp = async () => {
    setResendLoading(true);
    setShowResendTimer(false);
    setResendTimer(30);
    try {
      const response = await dispatch(resendOtp(phoneNumber));
      if (response.success) {
        setTimer(120);
        setIsBlocked(false);
        setIsTimerActive(true);
        setOtp(["", "", "", "", ""]);
        setSnackbar({
          open: true,
          message: "OTP has been resent successfully.",
          severity: "success",
        });
        setSentOtp(response.data);
      } else {
        setSnackbar({
          open: true,
          message: response.error?.message || "Failed to resend OTP.",
          severity: "error",
        });
      }
    } catch (err) {
      console.error("Error during resend OTP:", err);
      setSnackbar({
        open: true,
        message: "Unexpected error. Please try again.",
        severity: "error",
      });
    } finally {
      setResendLoading(false);
      const resendCountdown = setInterval(() => {
        setResendTimer((prev) => {
          if (prev <= 1) {
            clearInterval(resendCountdown);
            setShowResendTimer(true);
            return 0;
          }
          return prev - 1;
        });
      }, 1000);
    }
  };

  const handleCloseSnackbar = () => {
    setSnackbar((prevState) => ({ ...prevState, open: false }));
  };

  const formatTime = (seconds) => {
    const mins = Math.floor(seconds / 60);
    const secs = seconds % 60;
    return `${mins}:${secs.toString().padStart(2, '0')}`;
  };

  return (
    <Container
      sx={{
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center",
        minHeight: "100vh",
        backgroundColor: "#F8F9FA",
        backgroundImage: `url(${imge})`,
        backgroundSize: "cover",
        backgroundPosition: "center",
        backgroundRepeat: "no-repeat",
        padding: 2,
        position: "absolute",
        top: 0,
        left: 0,
        right: 0,
      }}
    >
      <Paper
        sx={{
          borderRadius: 5,
          boxShadow: 8,
          padding: { xs: 3, sm: 4 },
          maxWidth: 400,
          width: "100%",
          backgroundColor: "rgba(255, 255, 255, 0.95)",
        }}
      >
        {/* Header */}
        <Box sx={{ mb: 4, textAlign: "center" }}>
          <Box
            onClick={() => navigate("/")}
            sx={{
              display: "inline-flex",
              alignItems: "center",
              gap: 1,
              mb: 3,
              color: "#666",
              cursor: "pointer",
              "&:hover": { color: "#000" }
            }}
          >
            <ArrowBack fontSize="small" />
            <Typography variant="body2">Back to login</Typography>
          </Box>
          
          <Typography variant="h5" sx={{ fontWeight: 600, mb: 1, color: "#000" }}>
            Verify OTP
          </Typography>
          <Typography variant="body2" sx={{ color: "#666", mb: 2 }}>
            Enter the 5-digit code sent to
          </Typography>
          
          {/* Phone Number Display */}
          <Box
            sx={{
              display: "inline-flex",
              alignItems: "center",
              gap: 1,
              px: 2,
              py: 1,
              borderRadius: 1,
              backgroundColor: "#f8f9fa",
              border: "1px solid #e0e0e0",
            }}
          >
            <Phone sx={{ fontSize: 18, color: "#666" }} />
            <Typography
              variant="body1"
              sx={{
                fontWeight: 500,
                color: "#000",
                fontSize: "0.95rem",
              }}
            >
              {phoneNumber}
            </Typography>
          </Box>
        </Box>

        {/* OTP Input Fields - OUTLINED */}
        <Box sx={{ mb: 3 }}>
          <Typography variant="caption" sx={{ color: "#666", mb: 1, display: "block" }}>
            Enter OTP code:
          </Typography>
          <Box display="flex" justifyContent="center" gap={1}>
            {otp.map((digit, index) => (
              <TextField
                key={index}
                value={digit}
                onChange={(e) => handleOtpChange(e, index)}
                onKeyDown={(e) => handleKeyDown(e, index)}
                inputProps={{
                  maxLength: 1,
                  disabled: isBlocked,
                }}
                variant="outlined"
                sx={{
                  width: "50px",
                  "& .MuiOutlinedInput-root": {
                    backgroundColor: "#ffffff",
                    borderRadius: 1,
                    height: "50px",
                    fontSize: "20px",
                    fontWeight: 600,
                    textAlign: "center",
                    "&:hover fieldset": {
                      borderColor: "#000",
                    },
                    "&.Mui-focused fieldset": {
                      borderColor: "#000",
                      borderWidth: "2px",
                    },
                    "&.Mui-disabled": {
                      backgroundColor: "#f8f9fa",
                    },
                  },
                  "& input": {
                    textAlign: "center",
                    fontSize: "20px",
                    fontWeight: 600,
                    color: "#000",
                    padding: "8px",
                  },
                }}
                inputRef={(el) => (inputRefs.current[index] = el)}
              />
            ))}
          </Box>
        </Box>

        {/* Timer Display - OUTLINED */}
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            mb: 3,
            p: 1.5,
            borderRadius: 1,
            backgroundColor: isTimerActive ? "#f0f8ff" : "#fee",
            border: isTimerActive ? "1px solid #d1e9ff" : "1px solid #fcc",
          }}
        >
          <Timer
            sx={{
              fontSize: 18,
              mr: 1,
              color: isTimerActive ? "#2563eb" : "#dc2626",
            }}
          />
          {isTimerActive ? (
            <Typography
              variant="body2"
              sx={{
                fontWeight: 500,
                color: "#2563eb",
              }}
            >
              Code expires in: {formatTime(timer)}
            </Typography>
          ) : (
            <Typography
              variant="body2"
              sx={{
                fontWeight: 500,
                color: "#dc2626",
              }}
            >
              OTP expired. Request a new code.
            </Typography>
          )}
        </Box>

        {/* Verify Button - OUTLINED */}
        <LoadingButton
          onClick={handleOtpSubmit}
          loading={loading}
          variant="contained"
          fullWidth
          size="medium"
          disabled={isBlocked || otp.join("").length !== 5}
          sx={{
            bgcolor: "#1e0153",
            color: "#fff",
            borderRadius: 1,
            py: 1.5,
            mb: 2,
            border: "1px solid #000",
            "&:hover": {
              bgcolor: "#333",
              borderColor: "#333",
            },
            "&.Mui-disabled": {
              bgcolor: "#e0e0e0",
              borderColor: "#e0e0e0",
              color: "#999",
            },
          }}
        >
          Verify OTP
        </LoadingButton>

        {/* Resend OTP Section - OUTLINED */}
        {isBlocked && showResendTimer && (
          <LoadingButton
            onClick={handleResendOtp}
            loading={resendLoading}
            fullWidth
            variant="outlined"
            size="medium"
            startIcon={<Refresh fontSize="small" />}
            sx={{
              borderRadius: 1,
              py: 1.5,
              borderColor: "#e0e0e0",
              color: "#666",
              borderWidth: "1px",
              "&:hover": {
                borderColor: "#000",
                color: "#000",
                backgroundColor: "#f8f9fa",
                borderWidth: "1px",
              },
            }}
          >
            Resend OTP
          </LoadingButton>
        )}

        {!showResendTimer && (
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              p: 1.5,
              borderRadius: 1,
              backgroundColor: "#f8f9fa",
              border: "1px solid #e0e0e0",
              mb: 2,
            }}
          >
            <Timer sx={{ fontSize: 16, mr: 1, color: "#666" }} />
            <Typography
              variant="caption"
              sx={{
                fontWeight: 500,
                color: "#666",
              }}
            >
              Resend available in {resendTimer} seconds
            </Typography>
          </Box>
        )}

        {/* Footer Links */}
        <Box sx={{ textAlign: "center", mt: 3 }}>
          <Typography variant="caption" sx={{ color: "#999", display: "block", mb: 0.5 }}>
            Didn't receive the code?
          </Typography>
          <Link
            onClick={handleResendOtp}
            sx={{
              color: "#666",
              fontSize: "0.75rem",
              cursor: "pointer",
              "&:hover": { color: "#000", textDecoration: "underline" }
            }}
          >
            Request new code
          </Link>
          <Typography variant="caption" sx={{ color: "#999", mx: 1 }}>•</Typography>
          <Link
            onClick={() => navigate("/")}
            sx={{
              color: "#666",
              fontSize: "0.75rem",
              cursor: "pointer",
              "&:hover": { color: "#000", textDecoration: "underline" }
            }}
          >
            Change phone number
          </Link>
        </Box>

        {/* Snackbar for messages */}
        <Snackbar
          open={snackbar.open}
          autoHideDuration={4000}
          onClose={handleCloseSnackbar}
          anchorOrigin={{ vertical: "top", horizontal: "center" }}
        >
          <Alert
            onClose={handleCloseSnackbar}
            severity={snackbar.severity}
            variant="outlined"
            sx={{
              width: "100%",
              borderRadius: 1,
              fontSize: "0.875rem",
              fontWeight: 500,
              boxShadow: "0 4px 12px rgba(0, 0, 0, 0.1)",
            }}
          >
            {snackbar.message}
          </Alert>
        </Snackbar>
      </Paper>
    </Container>
  );
};

export default Verification;